import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useStore } from '../lib/store'
import Icon from './Icon'

export default function Toast() {
  const toasts = useStore((s) => s.toasts)
  const dismiss = useStore((s) => s.dismissToast)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted || typeof document === 'undefined') return null

  return createPortal(
    <div className="pointer-events-none fixed bottom-6 right-6 z-[999] flex w-80 flex-col gap-3">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role={toast.tone === 'error' ? 'alert' : 'status'}
          className="pointer-events-auto card border-white/10 px-4 py-3 text-sm shadow-elevated-md"
        >
          <div className="flex items-start gap-3">
            <Icon
              name={toast.tone === 'error' ? 'spark' : 'pulse'}
              className={toast.tone === 'error' ? 'text-rose-400' : 'text-sky-300'}
            />
            <div className="flex-1 text-neutral-100">{toast.message}</div>
            <button
              type="button"
              onClick={() => dismiss(toast.id)}
              className="rounded-full border border-white/10 bg-white/5 px-2 py-1 text-xs text-neutral-400 transition hover:border-white/20 hover:text-white"
            >
              Close
            </button>
          </div>
        </div>
      ))}
    </div>,
    document.body
  )
}
